export default __webpack_public_path__ + "static/media/image-sample-id-card.e38cfc75.png";